/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Empty_DescriptionInputs */



/**
* | output |
* | --- |
* | "Integrations expose extra tools to the AI for your organization. None ship with this build." |
*
* @param {Integrations_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_empty_description = /** @type {((inputs?: Integrations_Empty_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Empty_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Integrationen stellen der KI zusätzliche Werkzeuge für Ihre Organisation bereit. In dieser Version ist keine enthalten.")
	return /** @type {LocalizedString} */ ("Integrations expose extra tools to the AI for your organization. None ship with this build.")
});